export const ITEM_ACTIONS = Object.freeze({
  add: "add",
  substract: "substract",
});

export const UNASSIGNMENT_VARIANT = "Sin asignar";
